import Vue from 'vue';

import {
  ECF集計項目,
  E分析非表示フラグ,
  E勘定科目カテゴリ,
  E固変区分,
  E集計転記科目,
  E有無フラグ,
  E税区分,
  E補助科目フラグ,
} from '@/openapi/enum';
import { 勘定科目ListItemResponse } from '@/openapi/user';

export const new勘定科目ListItemResponse = (is通常科目フラグ = true): 勘定科目ListItemResponse => {
  return {
    pk: 0,
    cカテゴリ: E勘定科目カテゴリ.貸借,
    c補助科目フラグ: is通常科目フラグ ? E補助科目フラグ.通常 : E補助科目フラグ.補助,
    c並び順: 0,
    c大分類: '',
    c勘定科目: '',
    c分析非表示フラグ: E分析非表示フラグ.表示,
    c科目別計画フラグ: E有無フラグ.なし,
  };
};

export default Vue.extend({
  name: 'M勘定科目Mixin',

  data(): {
    eCF集計項目: typeof ECF集計項目;
    e税区分: typeof E税区分;
    e集計転記科目: typeof E集計転記科目;
    e固変区分: typeof E固変区分;
    e科目別計画フラグ: typeof E有無フラグ;
    e分析非表示フラグ: typeof E分析非表示フラグ;
  } {
    return {
      eCF集計項目: ECF集計項目,
      e税区分: E税区分,
      e集計転記科目: E集計転記科目,
      e固変区分: E固変区分,
      e科目別計画フラグ: E有無フラグ,
      e分析非表示フラグ: E分析非表示フラグ,
    };
  },

  methods: {
    is貸借カテゴリ(e勘定科目カテゴリ: E勘定科目カテゴリ): boolean {
      return e勘定科目カテゴリ === E勘定科目カテゴリ.貸借;
    },
    filter固定資産科目(勘定科目s: 勘定科目ListItemResponse[]): 勘定科目ListItemResponse[] {
      return 勘定科目s.filter(
        (勘) =>
          勘.cカテゴリ === E勘定科目カテゴリ.貸借 &&
          ((勘.c中分類 !== undefined && ['有形固定資産', '無形固定資産', '投資その他の資産'].includes(勘.c中分類)) ||
            勘.c大分類 === '繰延資産')
      );
    },
  },
});
